import { defaultPriceOptions, getPriceFormatted } from "@i22/rocket";
import Prices from "./component-library30.mjs";
import AddToCartButton from "./component-library50.mjs";
import "./component-library169.mjs";
import normalizeComponent from "./component-library81.mjs";
const _sfc_main = {
  name: "StickyCart",
  components: {
    Prices,
    AddToCartButton
  },
  props: {
    prices: { type: Array, default: () => [] },
    priceOptions: { type: Object, default: () => defaultPriceOptions }
  },
  emits: ["add-to-cart"],
  computed: {
    price() {
      return getPriceFormatted(this.prices, "DEFAULT", "ONETIME", this.priceOptions);
    },
    wasPrice() {
      return getPriceFormatted(this.prices, "WAS", "ONETIME", this.priceOptions);
    },
    priceMonthly() {
      return getPriceFormatted(this.prices, "DEFAULT", "MONTHLY", this.priceOptions);
    },
    wasPriceMonthly() {
      return getPriceFormatted(this.prices, "WAS", "MONTHLY", this.priceOptions);
    }
  }
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("div", { staticClass: "cart-sticky" }, [_c("div", { staticClass: "cart-sticky__prices" }, [_vm.price ? _c("Prices", { attrs: { "is-price": _vm.price, "was-price": _vm.wasPrice, "pre-text-was-price": "", "pre-text-is-price": "", "post-text-is-price": _vm.priceMonthly && !_vm.wasPrice ? "einmalig" : "", "post-text-was-price": _vm.priceMonthly && _vm.wasPrice ? "einmalig" : "" } }) : _vm._e(), _vm.priceMonthly ? _c("Prices", { attrs: { "is-price": _vm.priceMonthly, "was-price": _vm.wasPriceMonthly, "pre-text-was-price": "", "pre-text-is-price": "", "post-text-is-price": _vm.wasPriceMonthly ? "" : "monatlich", "post-text-was-price": _vm.wasPriceMonthly ? "monatlich" : "" } }) : _vm._e()], 1), _c("div", { staticClass: "cart-sticky__add-to-cart" }, [_vm._t("addToCart", function() {
    return [_c("AddToCartButton", { attrs: { "display-icon": "", "display-text": false }, on: { "add-to-cart": (args) => _vm.$emit("add-to-cart", args) } })];
  }), _vm._t("addToCartContent")], 2)]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "61813745",
  null,
  null
);
const cartSticky = __component__.exports;
export {
  cartSticky as default
};
